import React, { useState, useRef, useEffect } from 'react';
import { CloseOutlined, SendOutlined } from '@ant-design/icons';
import { Input, Spin } from 'antd';
import { Backdrop, Button, NoteMessage } from '..';
import Wrapper from './style';

const Index = (props) => {
  const {
    setShowNote,
    showNote,
    notes,
    onDeleteNote,
    onSubmitNote,
    noteTitle,
    noteSubtitle,
    loadingSubmit,
    loading,
    fetchMore,
    // loadingFetchMore,
  } = props;
  const [newNote, setNewNote] = useState('');
  const messagesEndRef = useRef(null);
  const reference = useRef();
  const [scrollBottom, setScrollBottom] = useState(true);

  const scrollToBottom = () => {
    if (scrollBottom) {
      messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };
  useEffect(() => {
    scrollToBottom();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notes, showNote]);

  const onCloseNote = () => {
    setShowNote(false);
    setScrollBottom(true);
  };

  const onClickSubmit = () => {
    setScrollBottom(true);
    onSubmitNote(newNote);
    setNewNote('');
    scrollToBottom();
  };

  const onScroll = () => {
    if (reference.current.scrollTop === 0 && fetchMore) {
      fetchMore({ setScrollBottom });
    }
  };

  return (
    <>
      <Backdrop show={showNote} onClickBackdrop={onCloseNote} />
      <Wrapper show={showNote} className="component_note">
        <div className="component_note_title">
          <div>
            <div className="font-subtitle1_medium black1">
              {noteTitle || 'Note Title'}
            </div>
            <div className="font-paragraph_medium black4">
              {noteSubtitle || ' '}
            </div>
          </div>
          <CloseOutlined onClick={onCloseNote} />
        </div>
        {loading && <Spin />}
        <div
          className="component_note_content"
          onScroll={onScroll}
          ref={reference}
        >
          {notes.map((note) => {
            return (
              <NoteMessage
                key={note.id}
                message={note}
                onDeleteNote={onDeleteNote}
              >
                {note.content}
              </NoteMessage>
            );
          })}
          <div ref={messagesEndRef} />
        </div>
        <div className="component_note_input">
          <Input.TextArea
            size="large"
            placeholder="Write note here.."
            autoSize={{ minRows: 1, maxRows: 4 }}
            value={newNote}
            onChange={(e) => {
              setNewNote(e.target.value);
            }}
          />
          <Button
            type="primary"
            htmlType="submit"
            onClick={onClickSubmit}
            loading={loadingSubmit}
          >
            <SendOutlined />
          </Button>
        </div>
      </Wrapper>
    </>
  );
};

export default Index;
